import { render, staticRenderFns } from "./test-task.vue?vue&type=template&id=520ddb60&scoped=true"
import script from "./test-task.vue?vue&type=script&lang=js"
export * from "./test-task.vue?vue&type=script&lang=js"
import style0 from "@/utils/style/public-style.css?vue&type=style&index=0&id=520ddb60&prod&scoped=true&lang=css&external"
import style1 from "./test-task.vue?vue&type=style&index=1&id=520ddb60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520ddb60",
  null
  
)

export default component.exports